module.exports = "/assets/data/0ffe4e6980693576e081d7bfbabe766e-KA12.data.json";